import { useNavigate, useParams } from "react-router-dom";
import UserMenu from "@/components/UserMenu";
import { StudentProfileView } from "@/components/profile/StudentProfileView";

export default function TeacherStudentPage() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate("/teacher"));
  return (
    <div className="min-h-screen bg-slate-50" data-testid="teacher-student-page">
      <div className="flex justify-end px-6 pt-3"><UserMenu roleLabel="Teacher" /></div>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 pb-10 pt-2">
        <StudentProfileView studentId={studentId} onBack={back} backLabel="Back to my class" />
      </main>
    </div>
  );
}
